export default {"src":"/_next/static/media/Apple.90ebf13f.svg","height":57,"width":156};